import React from 'react';
import './AboutMe.css';
import BG from "../../assets/about-Heading.svg";
import Contact from './Contact';
export default function AboutMe() {
  return (
		<main className='about-page'>
			<h1>About Me</h1>
			<div className='about-container'>
				<img src={BG} alt='' className='bg' />
				<img src='images/portrait.jpeg' alt='portrait' className='portrait' />
			</div>
			<p className='bio'>
				Hi! I’m Kirsten Griffin, a passionate cinematographer from Dallas,
				Texas. I graduated with my Bachelor of Arts in Media arts from the
				University of North Texas.
				<br />
				<br />
				I’ve been fortunate enough to gain experience in my craft through
				various settings from live performances & events to film sets. Due to my
				curiosity leading me to interesting places, I’m also a licensed Part 107
				Remote Pilot, practicing through my work as a Real Estate photographer.
				<br />
				<br />
				My goal with this passion of mine is to evoke memories and lasting
				emotions from every viewer. I thrive in collaborative environments and
				cherish the opportunity to work with other creative minds. And good
				stories deserve to be told no matter the scale. So, if you would like to
				book with me, please do so below! I also like to do a bit of
				photography. You can check that out in my Portfolio!
			</p>
			<Contact />
		</main>
	);
}
